import { ActionReducerMap, createSelector } from '@ngrx/store';
import * as fromAuth from './auth.reducers';
import * as fromEventSwitcher from './eventSwitcher.reducers';
import * as fromTab from './tab.reducers';

export interface State {
  tab: fromTab.TabState;
  eventSwitcher: fromEventSwitcher.EventSwitcherState;
  auth: fromAuth.AuthState;
}

export const reducers: ActionReducerMap<State> = {
  tab: fromTab.TabReducer,
  eventSwitcher: fromEventSwitcher.EventSwitcherViewReducer,
  auth: fromAuth.AuthReducer,
};

const getTabState = (state: State) => state.tab;

export const getTab = createSelector(getTabState, fromTab.getTab);

const getEventSwitcherState = (state: State) => state.eventSwitcher;

export const getEventSwitcherView = createSelector(getEventSwitcherState, fromEventSwitcher.getEventSwitcherView);

const getAuthState = (state: State) => state.auth;

export const getToken = createSelector(getAuthState, fromAuth.getToken);
